import React from 'react';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import NumbersButton from '@redturtle/volto-rt-blocks/components/Blocks/Numbers/NumbersButton';

const ViewBlock = ({ data }) => {
  return data.number ? (
      <div className="number-card">
        {data.number && (
          <div className="number">
            <h2>{data.number}</h2>
          </div>
        )}
        <div className="number-text">
          <TextBlockView data={{ value: data?.text ?? {} }} />
        </div>
        <NumbersButton data={data} />
      </div>
  ) : (
    <></>
  );
};

export default React.memo(ViewBlock);
